import React from 'react';

export default () => (
	<span className="GridInfo__emptyValue" style={{ color: '#e0e0e0', fontWeight: 600 }}>
		N/A
	</span>
);